import React from "react";
import { invoiceStatus } from "constants/constants";
import encoder from "int-encoder";

export const generateSerialNumber = (
  datetimeString: any,
  id: number,
  prefix: string
) => {
  const datetime = new Date(datetimeString);
  const year = datetime.toLocaleDateString("en-US", { year: "2-digit" });
  const month = datetime.toLocaleDateString("en-US", { month: "2-digit" });
  const monthYear = year + month;

  const newId = id?.toString().padStart(3, "0");

  return `${prefix}${monthYear}${newId}`;
};

export const getEncodedValue = (value: string | number) => {
  return encoder.encode(value);
};

export const getDecodedValue = (value: string) => {
  return encoder.decode(value);
};

/**
 * Calculate time difference between start and end time
 */
export const calculateTimeDifference = (startTime: string, endTime: string) => {
  const [startHours, startMinutes] = startTime.split(":").map(Number);
  const [endHours, endMinutes] = endTime.split(":").map(Number);

  const startDate = new Date();
  startDate.setHours(startHours);
  startDate.setMinutes(startMinutes);

  const endDate = new Date();
  endDate.setHours(endHours);
  endDate.setMinutes(endMinutes);

  let timeDiff = endDate.getTime() - startDate.getTime();
  if (timeDiff < 0) {
    timeDiff += 86400000; // add 24 hours in milliseconds to handle cases where endTime is before startTime
  }
  return timeDiff;
};

/**
 * Calculate and convert the given timediff to hours and minutes
 */
export const changeToHoursAndMinutes = (timeDiff: number) => {
  const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  let minutes: string | number = Math.floor((timeDiff / (1000 * 60)) % 60);
  minutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

  return { hours, minutes };
};


export const getDownloadFileName = (sr_number:string,user_id:number) =>{
const currentDate = new Date();
const year = currentDate.getFullYear().toString().slice(-2);
const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
const day = currentDate.getDate().toString().padStart(2, '0');
const formattedDate = `${year}${month}${day}`;
const name = `${formattedDate}_${sr_number}_CUST#_${user_id}.zip`;

return name
}